import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;

export const HeaderConfiguration = styled.div`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 3px;

    span {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 36px;
        display: flex;
        align-items: center;
        margin-top: -1px;
        color: #FFFFFF;
    }

    div {
        display: flex;
        justify-content: start;
        align-items: center;
        
    }
`

export const ContentContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`;

export const InputContainer = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 89px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    border-bottom: 1px solid #A7A7A7;
    
    input {
        margin: 0px 10px 0px 10px;
        width: 230px;
        height: 80px;
        border: none;
        outline: none;
        border-radius: 5px;

        font-family: 'Poppins';
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 24px;
        color: #636363;
    }

    button {
        border: none;
        background: none;
        cursor: pointer;
    }

    span {
        position: absolute;
        display: flex;
        align-items: center;
        width: 102px;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #00587A;
        right: 10px;
        top: 50%;
        cursor: pointer;
        transform: translate(0, -50%);
    }
`

export const KeyboardContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
`

export const Key = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    justify-self: center;

    width: 57px;
    height: 65px;
    border-radius: 3px;
    border: none;
    background-color: transparent;

    font-size: 2rem;
    color: #333;
    box-shadow: inset 0 0 0 1px rgba(255,255,255,.05), inset 0 1px 0 0 rgba(255,255,255,.45), inset 0 -1px 0 0 rgba(255,255,255,.15), 0 1px 0 0 rgba(255,255,255,.15);
    text-shadow: 0 1px rgba(255,255,255,.4);
    cursor: pointer;
`

export const ActionsGroupButtons = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    
    >button {
        margin-left: 10px;
        margin-right: 10px;
    }
`

export const Button = styled.button`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 40px;
    margin: 5px 0px 10px 0px;
    border: none;
    border-radius: 5px;
    
    background-color: green;
    color: #FFF;
    cursor: pointer;
`
